const $ = window.jQuery;

import errorManager from '@/rollbar.js';

const init = () => {
  try {
    $('.fc-next-button').click(function () {});

    $('.fc-prev-button').click(function () {});
  } catch (e) {
    errorManager(e);
  }
};

window.DomesticsCalendar = {
  init: init,
};
